var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FFBB00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38893 1.11133C3.24159 1.11133 3.10028 1.16986 2.99609 1.27405C2.89191 1.37823 2.83337 1.51954 2.83337 1.66688V18.3336C2.83337 18.4809 2.89191 18.6222 2.99609 18.7264C3.10028 18.8306 3.24159 18.8891 3.38893 18.8891C3.53627 18.8891 3.67758 18.8306 3.78177 18.7264C3.88595 18.6222 3.94448 18.4809 3.94448 18.3336V1.66688C3.94448 1.51954 3.88595 1.37823 3.78177 1.27405C3.67758 1.16986 3.53627 1.11133 3.38893 1.11133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 2.12244C16.8044 2.07368 16.7086 2.04801 16.6111 2.04801C16.5136 2.04801 16.4178 2.07368 16.3333 2.12244C15.2564 2.57517 14.0957 2.7948 12.9278 2.76688C11.9216 2.69326 10.9416 2.41138 10.05 1.93911C9.19255 1.47583 8.24888 1.19406 7.27779 1.11133C6.47637 1.1122 5.68315 1.27273 4.94446 1.58355V11.1113C5.66826 10.7153 6.48051 10.5089 7.30557 10.5113C8.12259 10.5924 8.91555 10.834 9.6389 11.2224C10.6723 11.7621 11.8084 12.0764 12.9722 12.1447C14.3081 12.1724 15.6343 11.9129 16.8611 11.3836C16.9527 11.3374 17.0298 11.2667 17.0837 11.1795C17.1377 11.0922 17.1664 10.9917 17.1667 10.8891V2.59466C17.1651 2.49866 17.1387 2.40469 17.09 2.32193C17.0414 2.23917 16.9721 2.17044 16.8889 2.12244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityHigh);
export default __webpack_public_path__ + "static/media/PriorityHigh.743f48ab.svg";
export { ForwardRef as ReactComponent };